import React, { Component } from 'react'
import './AreaOfOperations.css'
// let operations=['Details not available']
class AreaOfOperations extends Component {
    constructor(props) {
        super(props)

        this.state = {
            operations: ['Details not available']
        }
    }

    // componentWillReceiveProps(nextProps){
    //     operations=nextProps.transporter_data.zone;
    //     if(operations==undefined || operations==null){
    //         operations=['Details not available']

    //     }
    // }

    static getDerivedStateFromProps(nextProps, prevState) {
        // operations=nextProps.transporter_data.zone;
        // if(operations==undefined || operations==null){
        //     operations=['Details not available']
        // }
        if (nextProps.transporter_data.zone === undefined || nextProps.transporter_data.zone === null) {
            return {
                operations: ['Details not available']
            }
        }
        else {
            return {
                operations: nextProps.transporter_data.zone
            }
        }
    }
    render() {

        let p = this.state.operations.map((item, i) => {
            return <li key={i} className="aoplist">{(item).charAt(0).toUpperCase() + (item).substring(1).toLowerCase()}</li>
        })
        return (
            <>
                <div className="aopcard">
                    <div className="aopcontainer">
                        <span className="data_header">Area of Operations</span>
                        <ol className="aopol">
                            {p}
                        </ol>
                    </div>
                </div>
            </>
        )
    }
}

export default AreaOfOperations
